import script from "./GridLayout.vue?vue&type=script&lang=ts"
export * from "./GridLayout.vue?vue&type=script&lang=ts"

import "./grid-layout.scss?vue&type=style&index=0&lang=scss"

export default script